import React from 'react';
import {useI18n} from '../../../../../data/hooks/i18nHooks';
import {useParticipantsListEnabled} from '../../../../../data/hooks/participant/useParticipantsListEnabled';
import StartNetworkingGroup from '../../StartNetworkingGroup';
import StepUseFavorites from './StepUseFavorites';
import StepViewFavorites from './StepViewFavorites';
import icon from './icon.png';
import styles from './FavoriteGroup.module.scss';

function FavoriteGroup(props) {
    const {eventId} = props,
        i18n = useI18n(),
        participantsEnabled = useParticipantsListEnabled(eventId);

    return (
        <StartNetworkingGroup
            name={i18n['start.favorite']}
            description={i18n['start.favorite.intro']}
            visible={participantsEnabled}
            icon={icon}
            iconClassName={styles.icon}>
            <StepUseFavorites eventId={eventId} />
            <StepViewFavorites eventId={eventId} />
        </StartNetworkingGroup>
    );
}

export default FavoriteGroup;
